import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api, Discussion } from '../lib/api';

const ROLE_LABEL: Record<string, string> = {
  budget: '预算', site_pm: '现场 PM', gm: '总经理', finance: '财务', procurement: '采购',
  audit: '内审', commercial: '商务', design: '设计', exec: '终审', other: '其他',
};

export function DiscussionsThread({ pid, discussions }: { pid: string; discussions: Discussion[] }) {
  const qc = useQueryClient();
  const [author, setAuthor] = useState(() => localStorage.getItem('labor_author') ?? '');
  const [role, setRole] = useState(() => localStorage.getItem('labor_role') ?? 'procurement');
  const [body, setBody] = useState('');

  const post = useMutation({
    mutationFn: () => api(`/packages/${pid}/discussions`, { method: 'POST', body: JSON.stringify({ author_name: author, author_role: role, body_md: body }) }),
    onSuccess: () => {
      localStorage.setItem('labor_author', author);
      localStorage.setItem('labor_role', role);
      setBody('');
      qc.invalidateQueries({ queryKey: ['package', pid] });
    },
  });

  return (
    <div>
      {/* 改改 6/26: clarify what the 招标群 is for and that it's optional (no required action). */}
      <div className="card" style={{ marginBottom: 10, background: 'var(--paper)' }}>
        <div className="small muted">
          ℹ️ 招标群是招标小组的内部讨论与评审记录（<strong>可选，不影响流程推进</strong>）。在这里记录选择/排除某家劳务的理由、风险与建议，作为定标的决策依据并留痕备查。上传招标文件、邀请劳务后，<strong>这里无需任何必填操作</strong>——下一步直接等劳务报价、或在「对比与定标」中评审即可。
          <br />/ Optional internal tender-team thread for decision legibility — jot down reasoning, risks and recommendations. Nothing here is a required step.
        </div>
      </div>
      {discussions.length === 0 && <div className="empty">暂无讨论 / No comments yet</div>}
      {discussions.map((d) => (
        <div key={d.id} className="msg">
          <div className="meta">
            <span className="author">{d.author_name}</span>
            {d.author_role && <span> · {ROLE_LABEL[d.author_role] ?? d.author_role}</span>}
            <span> · {new Date(d.created_at).toLocaleString('zh-CN')}</span>
            {d.references_bid_id && <span className="anchor">引用 {d.references_bid_id.replace('demo_bid_', '')}</span>}
          </div>
          <div className="body">{d.body_md}</div>
        </div>
      ))}

      <div className="card" style={{ marginTop: 10 }}>
        <div className="row" style={{ gap: 8, marginBottom: 8 }}>
          <input placeholder="你的名字 / your name" value={author} onChange={(e) => setAuthor(e.target.value)} style={{ flex: '1 1 160px' }} />
          <select value={role} onChange={(e) => setRole(e.target.value)} style={{ flex: '0 0 130px' }}>
            {Object.entries(ROLE_LABEL).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
          </select>
        </div>
        <textarea placeholder="留言（决策理由会进审计记录） / comment (your reasoning is recorded for the decision-legibility metric)" rows={3} value={body} onChange={(e) => setBody(e.target.value)} />
        <div className="row" style={{ marginTop: 8 }}>
          <button className="btn-primary" disabled={!author || !body || post.isPending} onClick={() => post.mutate()}>{post.isPending ? '发送中…' : '发表 / Post'}</button>
        </div>
        {post.isError && <div className="small" style={{ color: 'var(--bad)', marginTop: 6 }}>{String((post.error as any)?.message)}</div>}
      </div>
    </div>
  );
}
